import React from 'react'

const CadentierSalesStoreSubcategory: React.FC = () => (
  <svg width="70" height="71" viewBox="0 0 70 71" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.0769043" width="70" height="70" rx="14.5455" fill="url(#paint0_linear_4674_17940)" />
    <path
      d="M44.558 20.8051H40.9698C40.1463 18.3346 37.7933 16.5699 35.0286 16.5699C32.2639 16.5699 29.911 18.3346 29.0286 20.8051H25.4404C23.6757 20.8051 22.2639 22.2169 22.2639 23.9816V47.3934C22.2639 49.1581 23.6757 50.5699 25.4404 50.5699H44.558C46.3227 50.5699 47.7345 49.1581 47.7345 47.3934V23.9816C47.7933 22.2757 46.3227 20.8051 44.558 20.8051ZM35.0286 20.8051C36.2051 20.8051 37.1463 21.7463 37.1463 22.9228C37.1463 24.0993 36.2051 25.0404 35.0286 25.0404C33.8522 25.0404 32.911 24.0993 32.911 22.9228C32.911 21.7463 33.8522 20.8051 35.0286 20.8051ZM41.0874 34.0404L35.2051 41.4522C34.911 41.8051 34.558 42.0404 34.0874 42.0404C34.0286 41.9816 33.9698 42.0404 33.911 42.0404C33.558 42.0404 33.1463 41.9228 32.8522 41.6287L29.1463 38.4522C28.4992 37.864 28.3816 36.864 28.9698 36.2169C29.558 35.5699 30.558 35.4522 31.2051 36.0404L33.6757 38.1581L38.4992 32.0404C39.0286 31.3346 40.0286 31.2169 40.7345 31.7463C41.4992 32.3346 41.6169 33.3346 41.0874 34.0404Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4674_17940"
        x1="34.5455"
        y1="0.0769046"
        x2="34.5455"
        y2="70.0769"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#07888D" />
        <stop offset="1" stopColor="#006064" />
      </linearGradient>
    </defs>
  </svg>
)

export default CadentierSalesStoreSubcategory
